<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">About Us</TextHeading>
      <TextHeading variant="lg" block>Company History</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <TextProse>
          <p>From Bradford market stall to the UK’s 4th largest supermarket chain</p>
        </TextProse>
        <CardTimeline v-for="item in items" v-bind:data="item" v-bind:key="item.id"></CardTimeline>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import CardTimeline from '../components/CardTimeline.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import CardDownload from '../components/CardDownload.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'CompanyHistory',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    CardDownload,
    PageMain,
    TextProse,
    CardTimeline,
    TheFooter
  },
  data() {
    return {
      items: [
        {
          year: '1899',
          titles: 'Stall opens in Bradford Market',
          details:
            'Egg and butter merchant William Morrison begins his business, set to become the company we know today.',
          image: require('@/assets/images/butter.png')
        },
        {
          year: '1931',
          titles: 'Sir Ken Morrison was born in Bradford',
          details: 'Lorem ipsum.',
          image: ''
        },
        {
          year: '1951',
          titles: 'Sir Ken Morrison took over',
          details:
            'Sir Ken Morrison, aged 21, took over the small group of Bradford market stalls from his father.',
          image: ''
        },
        {
          year: '1958',
          titles: 'First town-centre shop opens',
          details:
            'The first shop is opened with three checkouts, it is the only store in Bradford to offer self-service and to have prices on its products.',
          image: require('@/assets/images/history-first-shop.png')
        }
      ]
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>